// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResultHeading_wrapper__zk3Eh","searchTerm":"SearchResultHeading_searchTerm__78MFp","markdown":"SearchResultHeading_markdown__Ea9Bv"};